import { GlobalSearchParamsProvider } from '../../contexts/useSearchParamsContext';

export const withGlobalSearchParams = <ComponentProps extends Record<string, unknown>>(
  Component: React.ComponentType<ComponentProps>,
) => {
  return (componentProps: ComponentProps) => (
    <GlobalSearchParamsProvider>
      <Component {...componentProps} />
    </GlobalSearchParamsProvider>
  );
};
